// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"3b2e4219","453":"e79d21a7","530":"a529af6c","596":"fd25170a","979":"1c1d41c2"}[chunkId] + ".chunk.js";
};